import { Tooltip } from "chart.js";
import { tooltipPositioner, cursor } from "./tooltip";

export const RegisterPlugins = () => {
  Tooltip.positioners.tooltipPositioner = tooltipPositioner;
  Tooltip.positioners.cursor = cursor;
};
